<template>
  <van-popup :show="show" @update:show="$emit('update:show', $event)" :close-on-click-overlay="false"
    class="reward-dialog" round>
    <div class="reward-content">
      <!-- 顶部插图区域 -->
      <div class="reward-illustration">
        <!-- 老鼠图片 -->
        <img :src="getAssetsFile('activity/mouse.png')" alt="Reward" class="reward-image">
      </div>

      <!-- 文字和按钮区域 -->
      <div class="reward-text color-[#6A6A6A]">
        <p class="reward-message color-[#6A6A6A]">
          {{ t('wellowtdog.message') }}
          <span class="reward-amount"> {{ VITE_symbol }}{{ bettingMultiplier }}</span>
          {{ t('wellowtdog.multiplier') }}
        </p>

        <!-- 两个按钮 -->
        <div class="flex items-center justify-center gap-[10px]">
          <div class="   reward-button-primary" @click="handleSeeDetails">
            {{ t('wellowtdog.seeDetails') }}
          </div>
          <div class="reward-button-secondary" @click="handleConfirm">
            {{ t('wellowtdog.confirm') }}
          </div>
        </div>
      </div>

    </div>
  </van-popup>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'
import { getAssetsFile } from '@/utils/pub-use'
const VITE_symbol = import.meta.env.VITE_SYMBOL
const { t } = useI18n()
const router = useRouter()

interface Props {
  show: boolean
  bettingMultiplier: number
}

interface Emits {
  (e: 'update:show', value: boolean): void
  (e: 'confirm'): void
  (e: 'seeDetails'): void
}

const props = defineProps<Props>()
const emit = defineEmits<Emits>()

const handleConfirm = () => {
  emit('update:show', false)
  emit('confirm')
}

const handleSeeDetails = () => {
  // 关闭弹窗
  emit('update:show', false)
  // 跳转到chargebackRecord页面，并指定选中audit标签
  router.push('/wallet/chargebackRecord?tab=audit')
  emit('seeDetails')
}
</script>

<style scoped>
.reward-dialog {
  width: 80%;
  max-width: 320px;
  background: transparent;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.reward-content {
  padding-bottom: 0;
  text-align: center;
  background: #085D63;
  border-radius: 16px;
}

.reward-illustration {
  margin-bottom: 0;
  height: 160px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 16px 16px 0 0;
  position: relative;
  overflow: hidden;
  background: transparent;
}

.reward-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  position: relative;
  z-index: 2;
  border-radius: 16px 16px 0 0;
}

.reward-text {
  margin-bottom: 0;
  margin-top: -10px;
  background: white;
  padding: 20px;
  border-radius: 0 0 16px 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.reward-message {
  font-size: 16px;
  color: #6A6A6A;
  line-height: 1.4;
  margin: 0;
  margin-bottom: 20px;
}

.reward-amount {
  color: #EFC278;
  /* 橙色，根据图片中的颜色 */
  font-weight: bold;
  font-size: 18px;
}

.reward-button-primary {
  background: linear-gradient(180deg, #3CC35F 0%, #3A9857 100%);
  color: white;
  padding: 10px 20px;
  border-radius: 4px;
  font-size: 13px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(19, 199, 105, 0.3);
  flex: 1;
  text-align: center;
}

.reward-button-secondary {
  background: white;
  color: #3CC35F;
  padding: 10px 20px;
  border-radius: 4px;
  font-size: 13px;
  font-weight: bold;
  cursor: pointer;
  border: 1px solid #3CC35F;
  transition: all 0.3s ease;
  flex: 1;
  text-align: center;
}

.reward-button-primary:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(19, 199, 105, 0.4);
}

.reward-button-secondary:hover {
  background: #f0f9f0;
  transform: translateY(-1px);
}

.reward-button-primary:active,
.reward-button-secondary:active {
  transform: translateY(0);
}
</style>
